import RestApiModel from "@/api/Model/RestApiModel";

class CoverholderSaveQuote extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderSaveQuote';
  }
}

export default CoverholderSaveQuote;
